<form class="flex flex-col gap-4" (ngSubmit)="loginClick()">
  @if (!requiresOfficeSelection) {
    <div>
      <label for="email" appFormLabel>Email</label>
      <input [(ngModel)]="email" type="email" name="email" id="email" appFormInputText placeholder="example@alonso.com" required="">
    </div>
    <div>
      <label for="password" appFormLabel>Contraseña</label>
      <input [(ngModel)]="password" type="password" name="password" id="password" placeholder="••••••••" appFormInputText required="">
    </div>
    <div class="flex items-center justify-between">
      <a routerLink="/olvidaste-tu-contrasena" class="text-sm font-medium text-primary hover:underline ">¿Olvidaste tu contraseña?</a>
    </div>
    <button [disabled]="loading" type="submit" class="w-full disabled:bg-primary-750 disabled:cursor-progress text-white bg-primary hover:opacity-85 focus:ring-4 focus:outline-none focus:ring-primary font-medium rounded-lg text-sm px-5 py-2.5 text-center">
      Entrar
    </button>
  } @else {
    <div>
      <label appFormLabel>Sucursal</label>
      <!-- Selector de sucursal personalizado -->
      <div class="relative">
        <button type="button" (click)="toggleOfficeDropdown()"
          class="w-full flex items-center justify-between gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-left text-sm hover:border-primary focus:ring-2 focus:ring-primary focus:outline-none transition-colors"
          [class.border-primary]="officeDropdownOpen">
          <span class="flex items-center gap-2 min-w-0">
            <svg class="w-5 h-5 shrink-0 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" />
            </svg>
            <span class="truncate" [class.text-gray-400]="selectedOfficeId == null">{{ selectedOfficeName }}</span>
          </span>
          <svg class="w-4 h-4 shrink-0 text-gray-400 transition-transform" [class.rotate-180]="officeDropdownOpen"
            fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
          </svg>
        </button>
        @if (officeDropdownOpen) {
          <div class="absolute z-50 mt-1 left-0 right-0 rounded-lg border border-gray-100 bg-white shadow-lg overflow-hidden py-1 max-h-60 overflow-y-auto">
            @for (office of offices; track office.id) {
              <button type="button" (click)="selectOffice(office)"
                class="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 flex items-center gap-2"
                [class.font-semibold]="office.id === selectedOfficeId">
                <span class="w-1.5 h-1.5 rounded-full shrink-0" [class.bg-primary]="office.id === selectedOfficeId" [class.bg-transparent]="office.id !== selectedOfficeId"></span>
                <span class="truncate">{{ office.name }}</span>
              </button>
            }
          </div>
        }
      </div>
      <p class="mt-2 text-sm text-gray-500">Selecciona la sucursal en la que trabajarás hoy.</p>
    </div>
    <button [disabled]="loading || selectedOfficeId == null" type="submit" class="w-full disabled:bg-primary-750 disabled:cursor-progress text-white bg-primary hover:opacity-85 focus:ring-4 focus:outline-none focus:ring-primary font-medium rounded-lg text-sm px-5 py-2.5 text-center">
      Entrar
    </button>
    <button type="button" (click)="cancelOfficeSelection()" class="w-full text-sm font-medium text-primary hover:underline">
      Volver
    </button>
  }
</form>

